// Shared validation helpers for the app
export const PHONE_E164_WITH_10_DIGITS = /^[+]\d{1,3}\d{10}$/;

export const PHONE_E164_MESSAGE = 'Provide country code followed by 10 digit number, e.g. +919876543210';

export function isValidPhoneE164With10Digits(phone) {
  if (!phone) return false;
  return PHONE_E164_WITH_10_DIGITS.test(phone);
}

export function ensureString(v) {
  return v === undefined || v === null ? '' : String(v);
}
